var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd1fc210-65f3-43bc-9825-482ee0842a32",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.38 61.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M82.87,59.45v5.22a2.48,2.48,0,0,1-2.47,2.47H9.6a2.48,2.48,0,0,1-2.47-2.47V59.45",
    transform: "translate(-5.31 -6.59)",
    style: {
      fill: "#fff",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58,9.4A1.54,1.54,0,0,1,8.12,7.86H38.37a1.56,1.56,0,0,1,1,.4L45,13.35V64.94l-5.59-5.59a1.57,1.57,0,0,0-1.08-.45H8.12a1.53,1.53,0,0,1-1.54-1.53",
    transform: "translate(-5.31 -6.59)",
    style: {
      fill: "#fff",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.42,9.4a1.54,1.54,0,0,0-1.54-1.54H51.63a1.56,1.56,0,0,0-1,.4L45,13.35V64.94l5.59-5.59a1.57,1.57,0,0,1,1.08-.45H81.88a1.53,1.53,0,0,0,1.54-1.53",
    transform: "translate(-5.31 -6.59)",
    style: {
      fill: "#fff",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09,28.72",
    transform: "translate(-5.31 -6.59)",
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.13,28.72",
    transform: "translate(-5.31 -6.59)",
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.77,48.48",
    transform: "translate(-5.31 -6.59)",
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.82,48.48",
    transform: "translate(-5.31 -6.59)",
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.27,
    y1: 50.78,
    x2: 1.27,
    y2: 2.81,
    style: {
      fill: "#fff",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.11,
    y1: 50.78,
    x2: 78.11,
    y2: 2.81,
    style: {
      fill: "#fff",
      stroke: "#4f5ca6",
      strokeMiterlimit: 10,
      strokeWidth: "2.5446317463925px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 22.13,
    x2: 31.46,
    y2: 22.13,
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 32.01,
    x2: 31.46,
    y2: 32.01,
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.82,
    y1: 22.13,
    x2: 68.78,
    y2: 22.13,
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.82,
    y1: 32.01,
    x2: 68.78,
    y2: 32.01,
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 41.88,
    x2: 31.46,
    y2: 41.88,
    style: {
      fill: "#feca0d",
      stroke: "#c54f70",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.54513785960019px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.316a41011319a3554731c3b827af94e8.svg";
export { ForwardRef as ReactComponent };